import { createI18n } from 'vue-i18n'
import { getDeepObjVal } from '@functions/getDeepObjVal'

import { getDictArray  } from '@static/backend_shared_dicts/index.ts'
import { messages as localeMessages } from '@/locales/index.ts'

const languages = getDictArray( 'Languages' )

export class I18nUtils {
  static i18n = null

  static get locale() {
    return I18nUtils.i18n.global.locale
  }

  static setupI18n( options = { locale: 'en' } ) {
    options.missingWarn = import.meta.env.PROD
    options.fallbackWarn = import.meta.env.PROD
    // Словари лежат статикой в `src/locales`. Если у ключа нет значения в активной
    // локали (например, не заполнен `es`) — показываем английский вместо сырого пути ключа.
    // Полноту словарей проверяет `npm run translates:check`.
    options.fallbackLocale = options.fallbackLocale ?? 'en'

    const i18n = createI18n( options )

    window.$i18n = i18n.global

    I18nUtils.i18n = i18n
    return i18n
  }

  static setI18nLocale ( locale ) {
    if ( I18nUtils.i18n.mode === 'legacy' ) {
      I18nUtils.i18n.global.locale = locale
    } else {
      I18nUtils.i18n.global.locale.value = locale
    }

    document.querySelector( 'html' ).setAttribute( 'lang', locale )
  }

  /** Все переводы ключа сразу — нужно, когда значение уезжает на бэк во всех локалях (теги шаблонов). */
  static getTranslatesForMessage( message ) {
    const translates = {}

    for ( const { id } of languages ) {
      translates[ id ] = getDeepObjVal( localeMessages, `${ id }.${ message }` ) ?? `${ message }`
    }

    return translates
  }

}
